import { Fragment, memo } from "react";
import PropTypes from "prop-types";
import get from "lodash/get";
import { FormattedMessage } from "react-intl";
import AmountContainer from "app/pages/.shared/AmountContainer";
import NumberInputFormik from "app/pages/.shared/NumberInputFormik";

const checkMaxCount = (value, guest) => {
	return value < guest.maxGuest || !guest.maxGuest;
};
const checkMinCount = (value, guest) => {
	return (value > guest.minGuest || !guest.minGuest) && value !== 0;
};

const QuotationActivityGuest = ({ index, guests, onActivityChange }) => {
	return guests.map(guest => {
		const hasOnlyMinAge = guest.minAge && !guest.maxAge;
		const hasOnlyMaxAge = !guest.minAge && guest.maxAge;
		const hasMinAgeAndMaxAge = guest.minAge && guest.maxAge;
		const isForAllAges = !guest.minAge && !guest.maxAge;
		const isGuestIncluded = guest.includedGuest > 0;
		const guestPrice =
			guest.pricePerQuantity && guest.pricePerQuantity[1]
				? get(guest, "pricePerQuantity[1].price", 0)
				: 0;

		const showPrice = guestPrice > 0 || (guestPrice === 0 && !isGuestIncluded);

		return (
			<Fragment key={guest.code}>
				<div className="quotation-activity__counter">
					<div className="quotation-activity__person">
						{hasOnlyMinAge && (
							<Fragment>
								<div className="quotation-activity__age-label">
									<FormattedMessage
										id="quotation.activity.guest.age.label"
										tagName="span"
									/>{" "}
									<FormattedMessage
										id="quotation.activity.guest.age.min.label"
										values={{
											minAge: guest.minAge,
										}}
									/>
								</div>

								{showPrice && (
									<div className="quotation-activity__age">
										<FormattedMessage
											id="quotation.activity.guest.price.label"
											values={{
												price: <AmountContainer amount={guestPrice} />,
											}}
										/>
									</div>
								)}
							</Fragment>
						)}

						{hasMinAgeAndMaxAge && (
							<Fragment>
								<div className="quotation-activity__age-label">
									<FormattedMessage
										id="quotation.activity.guest.age.label"
										tagName="span"
									/>{" "}
									<FormattedMessage
										id="quotation.activity.guest.age.range.label"
										values={{
											minAge: guest.minAge,
											maxAge: guest.maxAge,
										}}
									/>
								</div>

								{showPrice && (
									<div className="quotation-activity__age">
										<FormattedMessage
											id="quotation.activity.guest.price.label"
											values={{
												price: <AmountContainer amount={guestPrice} />,
											}}
										/>
									</div>
								)}
							</Fragment>
						)}

						{hasOnlyMaxAge && (
							<Fragment>
								<div className="quotation-activity__age-label">
									<FormattedMessage
										id="quotation.activity.guest.age.label"
										tagName="span"
									/>{" "}
									<FormattedMessage
										id="quotation.activity.guest.age.max.label"
										values={{
											maxAge: guest.maxAge,
										}}
									/>
								</div>

								{showPrice && (
									<div className="quotation-activity__age">
										<FormattedMessage
											id="quotation.activity.guest.price.label"
											values={{
												price: <AmountContainer amount={guestPrice} />,
											}}
										/>
									</div>
								)}
							</Fragment>
						)}
						{isForAllAges && (
							<Fragment>
								<div className="quotation-activity__age-label">
									<FormattedMessage
										id="quotation.activity.guest.age.label"
										tagName="span"
									/>
								</div>

								{showPrice && (
									<div className="quotation-activity__age">
										<FormattedMessage
											id="quotation.activity.guest.price.label"
											values={{
												price: <AmountContainer amount={guestPrice} />,
											}}
										/>
									</div>
								)}
							</Fragment>
						)}
					</div>
					<div className="quotation-activity__input">
						<NumberInputFormik
							id={`activities[${index}].guests.${guest.code}`}
							name={`activities[${index}].guests.${guest.code}`}
							canIncrement={value => checkMaxCount(value, guest)}
							canDecrement={value => checkMinCount(value, guest)}
							onChange={value => {
								onActivityChange(value, guest);
							}}
						/>
					</div>
				</div>
			</Fragment>
		);
	});
};

QuotationActivityGuest.propTypes = {
	guests: PropTypes.array,
	activityCode: PropTypes.string,
	onActivityChange: PropTypes.func,
};

QuotationActivityGuest.defaultProps = {
	guests: [],
	onActivityChange: () => {},
};

export default memo(QuotationActivityGuest);
